import { combineReducers } from "redux";
import CartReducer from "slice/CartSlice";
import ProjectReducer from "slice/ProjectSlice";
import SessionReducer from "slice/SessionSlice";
import UserInfoReducer from "slice/UserSlice";
import DemoDatasourceReducer from "slice/demo/DemoDatasourceSlice";
import DemoProjectReducer from "slice/demo/DemoProjectSlice";
import DemoSessionReducer from "slice/demo/DemoSessionSlice";
import BaseApiUrlReducer from "slice/BaseApiUrlSlice";
import CommonReducer from "slice/CommonSlice";
import ConfigCatReducer from "slice/ConfigCatSlice";
import AuthReducer from "slice/AuthSlice";
import SessionRefreshReducer from "slice/SessionRefreshSlice";

const rootReducer = combineReducers({
  cart: CartReducer,
  project: ProjectReducer,
  session: SessionReducer,
  demoDatasource: DemoDatasourceReducer,
  demoProject: DemoProjectReducer,
  demoSession: DemoSessionReducer,
  userInfo: UserInfoReducer,
  baseApiUrl: BaseApiUrlReducer,
  common: CommonReducer,
  configCat: ConfigCatReducer,
  auth: AuthReducer,
  sessionRefresh: SessionRefreshReducer,
});

export default rootReducer;
